import Grid from "@mui/material/Unstable_Grid2";
import {observer} from "mobx-react";
import titleImage from "../../assets/img/ba--4.png";
import dustCoverImage from '../../assets/img/accessories/accessories_dust_covers.webp';
import backpackImage from '../../assets/img/accessories/accessories_backpack.webp';
import shoulderStrapsImage from '../../assets/img/accessories/accessories_shoulder_straps.webp';
import gloveImage from '../../assets/img/accessories/accessories_left_hand_glove.webp';
import React from "react";
import {Divider, Typography} from "@mui/material";
import TextImageComponent from "../Misc/TextImageComponent/TextImageComponent";
import {useStore} from "../../stores/Store";

export const AccessoriesPage = () => {
    const {LanguageStore: {currentLanguageMessages: clm}} = useStore();

    return (
        <Grid container sx={{justifyContent: 'center'}} rowSpacing={4}>
            <Grid xs={12}>
                <img src={titleImage} alt={'Title Image'} style={{width: '100%'}} />
            </Grid>
            <Grid xs={12} lg={10} xl={8} container>
                <Grid xs={12}>
                    <Typography textAlign={'center'} variant={'h4'}>{clm.AccessoriesPage.title}</Typography>
                    <Divider />
                </Grid>
                <Grid xs={12}>
                    <Typography textAlign={'center'}>{clm.AccessoriesPage.subtitle}</Typography>
                </Grid>
                <Grid container xs={12} spacing={2}>
                    <TextImageComponent
                        orderImage={{xs: 1, md: 1}}
                        orderText={{xs: 2, md: 2}}
                        text={clm.AccessoriesPage.Backpacks.text}
                        title={clm.AccessoriesPage.Backpacks.title}
                        image={backpackImage}
                        tableData={clm.AccessoriesPage.Backpacks.tableData}
                    />
                    <TextImageComponent
                        orderImage={{xs: 3, md: 4}}
                        orderText={{xs: 4, md: 3}}
                        text={clm.AccessoriesPage.ShoulderStraps.text}
                        title={clm.AccessoriesPage.ShoulderStraps.title}
                        image={shoulderStrapsImage}
                        tableData={clm.AccessoriesPage.ShoulderStraps.tableData}
                    />
                    <TextImageComponent
                        orderImage={{xs: 5, md: 5}}
                        orderText={{xs: 6, md: 6}}
                        text={clm.AccessoriesPage.AccordionDustCovers.text}
                        title={clm.AccessoriesPage.AccordionDustCovers.title}
                        image={dustCoverImage}
                        tableData={clm.AccessoriesPage.AccordionDustCovers.tableData}
                    />
                    <TextImageComponent
                        orderImage={{xs: 7, md: 8}}
                        orderText={{xs: 8, md: 7}}
                        text={clm.AccessoriesPage.AccordionGloveLeftHand.text}
                        title={clm.AccessoriesPage.AccordionGloveLeftHand.title}
                        image={gloveImage}
                        tableData={clm.AccessoriesPage.AccordionGloveLeftHand.tableData}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default observer(AccessoriesPage);